import Vue from 'vue'
import Vuex from 'vuex'

// import home from './home.module'
import auth from './modules/auth.module'
import users from './modules/users.module'
import projects from './modules/projects.module'
import articles from './modules/articles.module'
import tasks from './modules/tasks.module'
import stats from './modules/stats.module'
import attachments from './modules/attachments.module'
import messages from './modules/messages.module'
import surveys from './modules/surveys.module'
import commons from './modules/commons.module'
import {
    SET_LOADING,
    SET_TOGGLE
} from './mutations.type'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        auth,
        'ARTICLES': articles,
        'PROJECTS': projects,
        'MESSAGES': messages,
        'ATTACHMENTS': attachments,
        'SURVEYS': surveys,
        'STATS': stats,
        'TASKS': tasks,
        'COMMONS': commons,
        'USERS': users
    },
    mutations: {
        [SET_LOADING] (state, status) {
            state.isLoading = status
        },
        [SET_TOGGLE] (state, status) {
            state.isToggled = status
        }
    },
    state: {
        isLoading: false,
        isToggled: false
    },
    getters: {
        isLoading (state) {
            return state.isLoading
        },
        toggledSidebar (state) {
            return state.isToggled
        }
    }
})
